import React from "react";
import PropTypes from "prop-types";

import { TextWithImageWrapper, Header, Description } from "./style";

const GeneralTextWithHeading = (props) => {
	const { heading, content } = props;

	return (
		<TextWithImageWrapper>
			{heading && <Header>{heading}</Header>}
			<Description
				dangerouslySetInnerHTML={{
					__html: content,
				}}
			></Description>
		</TextWithImageWrapper>
	);
};

GeneralTextWithHeading.propTypes = {
	header: PropTypes.string,
	content: PropTypes.string,
};

GeneralTextWithHeading.defaultProps = {
	header: "",
	content: "",
};

export default GeneralTextWithHeading;
